import { useEffect, useState } from "react";
import api from "../../lib/api";
import AnimatedImage from "../../components/AnimatedImage";
import SeoHead from "../../components/SeoHead";

export default function Gallery() {
    const [photos, setPhotos] = useState([]);
    const [filter, setFilter] = useState("All");
    useEffect(() => { api.get("/gallery").then(({ data }) => setPhotos(data)).catch(() => {}); }, []);

    const categories = ["All", ...Array.from(new Set(photos.map((p) => p.category)))];
    const visible = filter === "All" ? photos : photos.filter((p) => p.category === filter);

    return (
        <div data-testid="gallery-page">
            <SeoHead pageKey="gallery" />
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-10">
                <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-4">Photo Gallery</div>
                <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] max-w-4xl mb-6">Faces, fields, and futures.</h1>
                <p className="text-lg text-muted-foreground max-w-3xl">Stories told in light — from peace dialogues to tree planting, classrooms to community wells.</p>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-6">
                <div className="flex flex-wrap gap-2 mb-8" data-testid="gallery-filters">
                    {categories.map((c) => (
                        <button
                            key={c}
                            onClick={() => setFilter(c)}
                            className={`px-4 py-2 rounded-sm text-xs uppercase tracking-[0.18em] border transition-colors ${
                                filter === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/60"
                            }`}
                            data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                        >{c}</button>
                    ))}
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {visible.map((p, i) => (
                        <figure
                            key={p.id}
                            className={`group relative overflow-hidden rounded-sm bg-card border border-border ${
                                i % 7 === 0 ? "sm:col-span-2 lg:row-span-2" : ""
                            }`}
                            data-testid={`gallery-photo-${p.id}`}
                        >
                            <div className={`${i % 7 === 0 ? "aspect-[4/3] lg:aspect-[4/5]" : "aspect-[4/3]"}`}>
                                <AnimatedImage src={p.image_url} alt={p.title || p.caption} className="w-full h-full" overrideType={p.animation_type || undefined} />
                            </div>
                            {(p.title || p.caption) && (
                                <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-foreground/85 via-foreground/40 to-transparent text-background opacity-0 group-hover:opacity-100 transition-opacity">
                                    {p.title && <div className="font-display text-lg leading-tight">{p.title}</div>}
                                    {p.caption && <div className="text-xs opacity-80 mt-0.5">{p.caption}</div>}
                                </figcaption>
                            )}
                        </figure>
                    ))}
                </div>
                {visible.length === 0 && <div className="text-center text-muted-foreground py-20">No photos in this category yet.</div>}
            </section>
        </div>
    );
}
